/**
 * Directive to display the different search levels (tender > lot > vcat > products > supplier)
 */
angular.module('impactx.displayelements').directive('ixSearchLevels', function () {
    return {
        scope: {
            trns : '=',
            tenders: '=',
            lots: '=',
            vcats: '=',
            products: '=',
            numOfPros: '=',
            suppliers: '=',
            withAdditionalInfo: "=",
            outletHeader: "@",
            outletsInfoHeader: "@",
            conditionsHeader: "@",
            cancelHeader: "@",
            infoHeader: "@",
            productLink: '@productLink'
        },
        restrict:'E',
        templateUrl: 'shared/displayelements/templates/searchlevels.html',
        controller: "SearchLevelsCtrl",
        controllerAs: "searchLevelsCtrl",
        transclude: true
    };
});